import type { FunctionalComponent } from "vue"

const IconFork: FunctionalComponent<any> = () => {
  return (
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2131_87)">
        <path
          d="M1.58341 11.55C1.58341 12.6251 2.49477 13.5 3.61466 13.5C4.73456 13.5 5.64591 12.6251 5.64591 11.55C5.64591 10.7037 5.07784 9.9887 4.29175 9.7196L4.29175 8.3C4.29175 7.94185 4.59508 7.65 4.96883 7.65L9.03133 7.65C9.40508 7.65 9.70841 7.94185 9.70841 8.3L9.70841 9.7196C8.92232 9.9887 8.35425 10.7037 8.35425 11.55C8.35425 12.6251 9.2656 13.5 10.3855 13.5C11.5054 13.5 12.4167 12.6251 12.4167 11.55C12.4167 10.7037 11.8487 9.9887 11.0626 9.7196L11.0626 8.3C11.0626 7.2249 10.1512 6.35 9.03133 6.35L7.67716 6.35L7.67716 4.2804C8.46326 4.0113 9.03133 3.2963 9.03133 2.45C9.03133 1.3749 8.11998 0.499998 7.00008 0.499999C5.88018 0.499999 4.96883 1.3749 4.96883 2.45C4.96883 3.2963 5.5369 4.0113 6.323 4.2804L6.323 6.35L4.96883 6.35C3.84893 6.35 2.93758 7.2249 2.93758 8.3L2.93758 9.7196C2.15149 9.9887 1.58341 10.7037 1.58341 11.55Z"
          fill="#9CA3AF"
        />
      </g>
      <defs>
        <clipPath id="clip0_2131_87">
          <rect width="13" height="13" fill="white" transform="translate(13.5 13.5) rotate(180)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconFork
